import { useMemo, useState } from 'react';
import { archiveCategories, archiveItems } from '@/mocks/home';

const statusStyle: Record<string, string> = {
  持续发酵: 'bg-primary-100 text-primary-800',
  待核实: 'bg-accent-100 text-accent-900',
  已回应: 'bg-secondary-100 text-secondary-900',
  最新更新: 'bg-secondary-100 text-secondary-900',
  高热度: 'bg-primary-100 text-primary-800',
};

export default function ArchiveSection() {
  const [active, setActive] = useState('全部');

  const list = useMemo(() => {
    if (active === '全部') return archiveItems;
    if (active === '高热度') return archiveItems.filter((item) => item.heat >= 80);
    return archiveItems.filter((item) => item.category === active);
  }, [active]);

  return (
    <section id="archive" className="bg-background-50 border-b border-background-200">
      <div className="mx-auto max-w-[1240px] px-4 md:px-8 py-8 md:py-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-5 md:mb-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">
              网红黑料档案
            </h2>
            <p className="mt-1.5 text-sm text-foreground-600">
              每条档案都标注状态与更新时间，标题优先，点开再决定要不要细看。
            </p>
          </div>
          <div className="flex items-center gap-1 p-1 rounded-full border border-background-200 bg-background-100 overflow-x-auto">
            {archiveCategories.map((category) => (
              <button
                key={category}
                type="button"
                onClick={() => setActive(category)}
                className={
                  active === category
                    ? 'px-3.5 py-1.5 rounded-full bg-foreground-950 text-background-50 text-xs font-medium whitespace-nowrap cursor-pointer'
                    : 'px-3.5 py-1.5 rounded-full text-xs text-foreground-600 hover:text-foreground-950 whitespace-nowrap cursor-pointer'
                }
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        {list.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {list.map((item) => (
              <article
                key={item.id}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="relative w-full h-40 bg-background-200 overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} - 网红黑料档案配图`}
                    title={`${item.codename} 网红黑料档案`}
                    className="w-full h-full object-cover object-top"
                  />
                  <span className={`absolute top-2.5 left-2.5 text-[11px] font-medium px-2 py-0.5 rounded-full ${statusStyle[item.category] ?? 'bg-background-100 text-foreground-700'}`}>
                    {item.category}
                  </span>
                  <span className="absolute top-2.5 right-2.5 text-[11px] text-background-50 bg-foreground-950/60 px-2 py-0.5 rounded-full">
                    {item.date}
                  </span>
                </div>
                <div className="flex-1 flex flex-col p-4">
                  <h3 className="text-sm font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs text-foreground-500">{item.codename}</p>
                  <div className="mt-3 flex flex-wrap gap-1.5">
                    {item.tags.map((tag) => (
                      <span key={tag} className="text-[11px] text-foreground-600 bg-background-100 px-2 py-0.5 rounded-full">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="mt-auto pt-3 flex items-center justify-between text-[11px] text-foreground-500 border-t border-background-200">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-fire-line text-primary-600" />
                      热度 {item.heat}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-chat-3-line" />
                      {item.comments}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-100/60 px-4 py-12 text-center">
            <i className="ri-inbox-archive-line text-2xl text-foreground-400" />
            <p className="mt-2 text-sm text-foreground-600">该状态下暂无档案，换个筛选试试。</p>
          </div>
        )}

        <div className="mt-5 flex items-center justify-center">
          <button
            type="button"
            className="inline-flex items-center gap-2 h-10 px-5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 whitespace-nowrap cursor-pointer hover:border-foreground-400 transition-colors"
          >
            <i className="ri-archive-drawer-line" />
            查看全部 1,842 份档案
          </button>
        </div>
      </div>
    </section>
  );
}